export const notificationSystemStyles = {
  container: {
    position: 'fixed' as const,
    top: 16,
    right: 16,
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 1,
    maxWidth: 400,
    width: '100%',
    '@media (max-width: 600px)': {
      top: 8,
      right: 8,
      left: 8,
      maxWidth: 'none',
    },
  },
  containerError: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 0,
    maxWidth: 'none',
    width: '100%',
  },
  notification: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    padding: 2,
    borderRadius: 1,
    boxShadow: 2,
    backgroundColor: 'background.paper',
    border: '1px solid',
    animation: 'slideInRight 0.3s ease-out',
  },
  notificationSuccess: {
    borderColor: 'success.main',
    backgroundColor: 'success.light',
    color: 'success.contrastText',
    borderRadius: 0,
    margin: 0,
    width: '100%',
    maxWidth: 'none',
  },
  notificationWarning: {
    borderColor: 'warning.main',
    backgroundColor: 'warning.light',
    color: 'warning.contrastText',
    borderRadius: 0,
    margin: 0,
    width: '100%',
    maxWidth: 'none',
  },
  notificationError: {
    borderColor: 'error.main',
    backgroundColor: 'error.light',
    color: 'error.contrastText',
    borderRadius: 0,
    margin: 0,
    width: '100%',
    maxWidth: 'none',
  },
  notificationInfo: {
    borderColor: 'info.main',
    backgroundColor: 'info.light',
    color: 'info.contrastText',
    borderRadius: 0,
    margin: 0,
    width: '100%',
    maxWidth: 'none',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    marginBottom: 0.5,
  },
  message: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
  },
  closeButton: {
    padding: 0.5,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  icon: {
    fontSize: '1.25rem',
    marginTop: 0.25,
  },
};